export const CO_GET_SUPPLIERNAME_LISTING = "CO_GET_SUPPLIERNAME_LISTING"
export const CO_GET_SUPPLIERNAME_LISTING_SUCCESS = "CO_GET_SUPPLIERNAME_LISTING_SUCCESS"
export const CO_GET_SUPPLIERNAME_LISTING_FAILED = "CO_GET_SUPPLIERNAME_LISTING_FAILED"
